<template>
  <div class="data-list">
    <div class="data-list-header">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">进行中活动</div>
            <div class="number">1234</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">已结束活动</div>
            <div class="number">1234</div>
          </el-card>
        </el-col>
       
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">参与经销商</div>
            <div class="number">1234</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">参与职员</div>
            <div class="number">1234</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">拉新人数</div>
            <div class="number">1234</div>
          </el-card>
        </el-col>
        <el-col :span="4">
          <el-card :body-style="{ padding: '0' }">
            <div class="header">参与人数</div>
            <div class="number">1234</div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="100px"
          >
            <el-form-item label="区经理编码" prop="activityId" label-width="120px">
              <el-input
                class="form-input"
                v-model="searchForm.activityId"
                size="small"
                clearable
                placeholder="请输入编码"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="区经理名称"
              prop="activityName"
              label-width="120px"
            >
              <el-input
                class="form-input"
                v-model="searchForm.activityName"
                size="small"
                clearable
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">查询</el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleAdd(null, 1)">导出</el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column
            prop="activityId"
            label="区经理编码"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="activityName"
            label="区经理名称"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="tmpName"
            label="经销商数"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="createdUserName"
            label="活动创建数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="joinStaffNumber"
            label="参与活动数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="browsePeopleNumber"
            label="用户拉新数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="signUpNumber"
            label="参与用户数"
            align="center"
          ></el-table-column>
          <el-table-column
            label="操作"
            class-name="action-column"
            align="center"
          >
            <template v-slot="scope">
              <el-button
                type="text"
                size="small"
                @click="handleAdd(scope.row, 3)"
              >
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [tableMixin,pagePathMixin],
  data() {
    return {
      searchForm: {
        activityId: "",
        activityName: "",
        tmpName: "",
        createdUserName: "",
        updatedTime: [],
        dataType: "",
      },

      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 20,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      actionType: 1,
      isShowAdd: false,
      modifyData: null,
    };
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.ActivityManagement.activityList(params)
        .then(({ data: { list, total } }) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(row) {
      this.selection = row;
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === "updatedTime" && val) {
          this.filterParam.startTime = val[0] || "";
          this.filterParam.endTime = val[1] || "";
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    handleAdd(row, actionType) {
      this.actionType = actionType;
      this.modifyData = row || null;
      this.isShowAdd = true;

      if (actionType == 3) {
        this.openSubPage({
          name: "dealerList",
          params: row,
        });
      }
    }
  },
  filters: {},
  created() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.data-list {
  .date-input {
    width 220px !important
  }
  .data-list-header {
    margin: 6px 16px;
    .header {
      color: #ccc;
      text-align: center;
      padding: 6px 0;
      border-bottom: 1px solid #ccc;
    }
    .number {
        text-align: center;
        padding: 6px 0;
    }
  }
}
</style>
